// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__bqE5Y","disabled":"FileBtn_disabled__3uKOW","warn":"FileBtn_warn__1c77S","fade":"FileBtn_fade__3CVkK"};